import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TenantUserMapping = React.lazy(() =>
    import('../TenantUserMapping')
);
const tenantUserMappingRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_USER_MAPPING_PAGE,
        element: <TenantUserMapping />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantUserMappingRoutesRegistry;
